var map = {
	"./accountInfo.svg": 87320,
	"./announcements.svg": 90289,
	"./bill.svg": 64036,
	"./chart.svg": 25473,
	"./delete.svg": 2126,
	"./group.svg": 29572,
	"./home.svg": 58226,
	"./language.svg": 53841,
	"./negotiation.svg": 42614,
	"./outLogin.svg": 11932,
	"./receipt-tax.svg": 83633,
	"./search.svg": 99211,
	"./tips.svg": 48897,
	"./user.svg": 43974,
	"./whs.svg": 38497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;